const integrations = {
	cookiebot: {
		title: 'Integrations > Cookiebot',
		labels: {
			enabled: 'Integration enabled',
			id: 'ID',
			script: 'Script (optional, replaces ID)',
		}
	},
	openai: {
		title: 'Integrations > OpenAI',
		labels: {
			enabled: 'Integration enabled',
			apiKey: 'API Key',
			model: 'Model',
		}
	},
	recaptcha: {
        title: 'Integrations > reCaptcha',
		labels: {
			enabled: 'Integration enabled',
			secretKey: 'Secret key',
			siteKey: 'Site key',
		}
    },
    p24: {
        title: 'Integrations > Przelewy24',
		labels: {
			enabled: 'Integration enabled',
			merchantId: 'Merchant ID',
			posId: 'POS ID',
			apiUrl: 'API Url',
			returnUrl: 'Return Url',
			statusUrl: 'Status Url',
			crcKey: 'CRC Key',
			reportKey: 'Report Key',
			redirectUrl: 'Redirect Url',
			sessionIdTemplate: 'Session ID Template',
			descriptionTemplate: 'Description Template',
			transferLabelTemplate: 'Transfer Label Template'
		}
    },
    payu: {
        title: 'Integrations > PayU',
		labels: {
			enabled: 'Integration enabled',
			authUrl: 'Authorization Url',
			apiUrl: 'API Url',
			statusUrl: 'Status Url',
			posId: 'POS ID',
			clientId: 'Client ID',
			secondKeyMd5: 'MD5 Key',
			clientSecret: 'Client Secret',
			descriptionTemplate: 'Description Template',
			returnUrl: 'Return Url'
		}
    },
    inpost: {
        title: 'Integrations > InPost',
		labels: {
			enabled: 'Integration enabled',
			apiUrl: 'API Url',
			acceptLanguage: 'Language',
			organizationId: 'Organization ID',
			token: 'Token',

			defaultSenderCompanyName: 'Nazwa firmy',
			defaultSenderEmail: 'Email',
			defaultSenderPhone: 'Nr telefonu',
			defaultSenderAddress: 'Adres',
			defaultSenderFirstName: 'Imię',
			defaultSenderLastName: 'Nazwisko',

			defaultCustomAttributesDropoffPoint: 'Punkt nadania (dropoff_point)',
			defaultServiceType: 'Usługa',
			defaultCustomAttributesSendingMethod: 'Metoda wysyłki',

			defaultShipmentHeight: 'Wysokość [cm]',
			defaultShipmentLength: 'Długość [cm]',
			defaultShipmentWidth: 'Szerokość [cm]',

			defaultShipmentWeightAmount: 'Waga [kg]',

			defaultShipmentIsNonStandard: 'Przesyłka niestandardowa',

			defaultCodAmount: 'Ilość',
			defaultCodCurrency: 'Waluta',

			defaultInsuranceAmount: 'Ilość',
			defaultInsuranceCurrency: 'Waluta',

			defaultAdditionalServiceCod: 'Cod',
			defaultAdditionalServiceInsurance: 'Ubezpieczenie',
			defaultAdditionalServiceSms: 'Sms',
			defaultAdditionalServiceEmail: 'Email',
			defaultAdditionalServiceSaturday: 'Sobota',
			defaultAdditionalServiceDor1720: 'Do drzwi 17-20',
			defaultAdditionalServiceForhour9: 'Do godziny 9',
			defaultAdditionalServiceForhour10: 'Do godziny 10',
			defaultAdditionalServiceForhour11: 'Do godziny 11',
			defaultAdditionalServiceForhour12: 'Do godziny 12',
			defaultAdditionalServiceForhour13: 'Do godziny 13',
			defaultAdditionalServiceForhour14: 'Do godziny 14',
			defaultAdditionalServiceForhour15: 'Do godziny 15',
			defaultAdditionalServiceForhour16: 'Do godziny 16',
			defaultAdditionalServiceForhour17: 'Do godziny 17',
			defaultAdditionalServiceRod: 'Rod',

			defaultMpk: 'Miejsce powstawania kosztów',
			defaultComments: 'Komentarz'
		},
		headers: {
			urls: 'Dane dostępowe do API',
			sender: 'Domyślne dane nadawcy',
			customAttributes: 'Dodatkowe atrybuty',
			shipment: 'Domyślne ustawienia paczki',
			cod: 'Cod',
			insurance: 'Ubezpieczenie',
			additionalService: 'Dodatkowe ustawienia',
			other: 'Inne',
		}
    },
    apaczka: {
        title: 'Integracje > APaczka',
		labels: {
			enabled: 'Integracja włączona',
			apiUrl: 'API Url',
			appId: 'API Id',
			appSecret: 'API Secret',
			pickupName: 'Imię i nazwisko',
			pickupCity: 'Miasto',
			pickupPostalCode: 'Kod pocztowy',
			pickupLine1: 'Adres - linia 1',
			pickupLine2: 'Adres - linia 2',
			pickupContactPerson: 'Osoba kontantowa',
			pickupEmail: 'Email',
			pickupPhone: 'Nr telefonu',
			pickupCountryCode: 'Kod kraju',
			pickupIsResidential: 'Is residential',
			pickupForeignAddressId: 'Foreign address id',

			defaultPickupType: 'Typ',
			defaultPickupDate: 'Data',
			defaultPickupHoursFrom: 'Godziny od',
			defaultPickupHoursTo: 'Godziny do',

			defaultOptionSmsNotification: 'Powiadomienia sms',
			defaultOptionRod: 'Rod',
			defaultOptionDelivaryOnSaturday: 'W sobotę',
			defaultOptionDelivaryInHours: 'W godzinach',
			defaultOptionBeCarefull: 'Ostrożnie',

			defaultNotificationNewReceiverEmail: 'Nowa - powiadamiaj odbiorcę emailem',
			defaultNotificationNewReceiverSms: 'Nowa - powiadamiaj odbiorcę smsem',
			defaultNotificationNewSenderEmail: 'Nowa - powiadamiaj nadawcę smsem',
			defaultNotificationSentReceiverEmail: 'Wysłana - powiadamiaj odbiorcę emailem',
			defaultNotificationSentReceiverSms: 'Wysłana - powiadamiaj odbiorcę smsem',
			defaultNotificationSentSenderEmail: 'Wysłana - powiadamiaj nadawcę smsem',
			defaultNotificationExceptionReceiverEmail: 'Błąd - powiadamiaj odbiorcę emailem',
			defaultNotificationExceptionReceiverSms: 'Błąd - powiadamiaj odbiorcę smsem',
			defaultNotificationExceptionSenderEmail: 'Błąd - powiadamiaj nadawcę smsem',
			defaultNotificationDeliveredReceiverEmail: 'Dostarczona - powiadamiaj odbiorcę emailem',
			defaultNotificationDeliveredReceiverSms: 'Dostarczona - powiadamiaj odbiorcę smsem',
			defaultNotificationDeliveredSenderEmail: 'Dostarczona - powiadamiaj nadawcę smsem',

			defaultCodAmount: 'Ilość',
			defaultCodBankaccount: 'Konto bankowe',

			defaultShipmentDimension1: 'Wymiar A',
			defaultShipmentDimension2: 'Wymiar B',
			defaultShipmentDimension3: 'Wymiar C',
			defaultShipmentWeight: 'Waga',
			defaultShipmentIsNstd: 'Is Nstd',
			defaultShipmentContentDescription: 'Opis zawartości',
			defaultShipmentServiceId: 'Usługa',
			defaultShipmentTypeCode: 'Rodzaj przesyłki',
		},
		headers: {
			urls: 'Dane dostępowe do API',
			senderAddress: 'Adres nadawcy',
			defaultPickup: 'Domyślne ustawienia nadania',
			defaultOptions: 'Domyślne opcje',
			defaultNotifications: 'Domyślne powiadomienia',
			defaultCod: 'Domyślne COD',
			defaultShipment: 'Domyślne ustawienia przesyłki'
		}
    },
    furgonetka: {
        title: 'Integracje > Furgonetka',
		labels: {
			enabled: 'Integracja włączona',

			apiUrl: 'API Url',
			authUrl: 'Auth Url',
			clientId: 'Client ID',
			clientSecreet: 'Client secreet',
			userEmail: 'Adres email logowania',
			userPassword: 'Hasło logowania',

			pickupName: 'Imię i nazwisko',
			pickupNameTooltip: 'Wymagane jeśli nie jest uzupełnione pole "Nazwa firmy", minimum 2 znaki dla imienia oraz 2 znaki dla nazwiska, całkowita długość pola minimum 6 znaków, maksymalnie 90 znaków. DHL - max 60 znaków, UPS - max 30 znaków',
			pickupCompany: 'Nazwa firmy',
			pickupCompanyTooltip: 'Wymagane jeśli nie jest uzupełnione pole "Imię i nazwisko", minimum 2 znaki, maksymalnie 80 znków. DHL - max 60 znaków, FedEx - max 150 znaków, UPS - max 30 znaków',
			pickupStreet: 'Ulica, numer domu i lokalu',
			pickupPostcode: 'Kod pocztowy',
			pickupCity: 'Miasto',
			pickupCountryCode: 'Kod kraju w formacie ISO 3166-1 alpha-2',
			pickupCounty: 'County',
			pickupCountyTooltip: 'Wymagane dla Irlandii (nazwa hrabstwa), Stanów Zjednoczonych (skrót stanu / kod ISO), Kanady (Kod pocztowy prowincji / kod ISO)',
			pickupEmail: 'E-mail',
			pickupPhone: 'Numer telefonu',

			pickupPoint: 'Punkt nadania',

			defaultShipmentServiceId: 'Usługa',
			defaultShipmentType: 'Rodzaj przesyłki',
			defaultShipmentWidth: 'Długość paczki w cm',
			defaultShipmentDepth: 'Szerokość paczki w cm',
			defaultShipmentHeight: 'Wysokość paczki w cm',
			defaultShipmentWeight: 'Waga paczki w kg',
			defaultShipmentValue: 'Wartość przesyłki w PLN',
			defaultShipmentValueTooltip: '(od podania tej wartości zależy ubezpieczenie przesyłki). W przypadku włączenia usługi COD wartość przesyłki nie może być mniejsza od wartości pobrania',
			defaultShipmentDescription: 'Opis zawartości paczki (od 2 do 100 znaków)',
			defaultShipmentDescriptionTooltip: 'DHL - wymagany (od 2 do 30 znaków) DPD - opcjonalny (jeżeli kraj odbiorcy "PL") FedEx - wymagany GLS - opcjonalny InPost - opcjonalny InPost Kurier - opcjonalny (jeżeli kraj odbiorcy "PL") Meest - opcjonalny Poczta Polska - opcjonalny Paczka w RUCHu - opcjonalny UPS - opcjonalny (jeżeli kraj odbiorcy "PL", od 2 do 50 znaków) Allegro - wymagany od 2 do 50 znaków - jak w UPS',

			defaultCodAmount: 'Wartość pobrania w PLN',
			defaultCodExpress: 'Usługa pobraniowa Express',
			defaultCodExpressTooltip: 'Kwota pobrania wysyłana jest nadawcy 1 dzień roboczy po dostarczeniu przesyłki. Usługa dostępna dla: DPD, FedEx, InPost Kurier',
			defaultCodIban: 'Numer rachunku bankowego.',
			defaultCodName: 'Właściciel rachunku bankowego.',

			defaultAdditionalServiceRod: 'Dokumenty zwrotne.',
			defaultAdditionalServiceCud: 'Usługa "Przesyłka zwrotna" polega na przyjęciu od Odbiorcy, przy wydawaniu mu Przesyłki, innej przesyłki adresowanej do Nadawcy Przesyłki pierwotnej (wyklucza się z usługą "Dokumenty zwrotne")',
			defaultAdditionalServicePrivateShipping: 'Doręczenie do osoby prywatnej.',
			defaultAdditionalServiceGuarantee0930: 'Doręczenie do godziny 9:30 / 10:30.',
			defaultAdditionalServiceGuarantee1200: 'Doręczenie do godziny 12:00.',
			defaultAdditionalServiceSaturdayDelivery: 'Doręczenie w sobotę. Wymagane jest, aby data nadania wypadała w piątek.',
			defaultAdditionalServiceAdditionalHandling: 'Element niestandardowy.',
			defaultAdditionalServiceSmsPredeliveryInformation: 'Awizacja SMS-owa doręczenia.',
			defaultAdditionalServiceDocumentsSupply: 'Usługa dostarczenia dokumentów przewozowych przez firmę kurierską.',
			defaultAdditionalServiceSaturdaySundayDelivery: 'Usługa "Paczka w Weekend" - doręczenie przesyłki do paczkomatu w sobotę lub niedzielę, przesyłka powinna być nadana od czwartku od godziny 20:00 do soboty do godziny 13:00.',
			defaultAdditionalServiceGuaranteeNextDay: 'Doręczenie w następnym dniu roboczym.',
			defaultAdditionalServiceFedexPriority: 'Usługa Fedex Priority - czas doręczenia nawet dwukrotnie szybszy od opcji Economy (do 3 dni roboczych). Dostępny dla przesyłek międzynarodowych.',
			defaultAdditionalServiceUpsSaver: 'UPS Express Saver.',
			defaultAdditionalServiceValuableShipment: 'Usługa "Przesyłka wartościowa".',
			defaultAdditionalServiceFragile: 'Usługa "Ostrożnie".',
			defaultAdditionalServicePersonalDelivery: 'Usługa "Doręczenie do rąk własnych" polega na zapewnieniu wydania Przesyłki wyłącznie Odbiorcy wskazanemu na Potwierdzeniu Nadania, którego tożsamość zostanie zweryfikowana przez Kuriera na podstawie dokumentu tożsamości.',
			defaultAdditionalServicePocztaKurier48: 'Usługa "Kurier48". Domyślna usługa dla przesyłek krajowych. Wyklucza się z usługami: Ekspres24, Polecony, Przesyłka firmowa polecona, Polecony zagraniczny, Global expres',
			defaultAdditionalServiceRegisteredLetter: 'Usługa "Polecony". Wyklucza się z usługami: Ekspres24, Kurier48, Przesyłka firmowa polecona, Polecony zagraniczny, Global expres',
			defaultAdditionalServiceRegisteredCompanyLetter: 'Usługa "Przesyłka firmowa polecona" polega na nadaniu przesyłki za potwierdzeniem nadania i doręczenia za pokwitowaniem odbioru. Może występować też pod nazwą "polecony ecommerce". Wyklucza się z usługami: Ekspres24, Kurier48, Polecony, Polecony zagraniczny, Global expres',
			defaultAdditionalServiceRegisteredLetterInternational: 'Usługa "Polecony Zagraniczny". Domyślna usługa dla międzynarodowych przesyłek typu "Koperta". Wyklucza się z usługami: Ekspres24, Kurier48, Polecony, Przesyłka firmowa polecona, Global expres',
			defaultAdditionalServicePocztaGlobalexpres: 'Usługa "Global Expres". Domyślna usługa dla międzynarodowych przesyłek typu "Przesyłka". Wyklucza się z usługami: Ekspres24, Kurier48, Polecony, Przesyłka firmowa polecona, Polecony zagraniczny',
			defaultAdditionalServiceDeliveryConfirmation: 'Usługa "Potwierdzenie odbioru przesyłki" polega na doręczeniu nadawcy formularza "Potwierdzenie odbioru" z pokwitowaniem odbioru przesyłki dokonanym przez odbiorcę. Występuje tylko w połączeniu z usługą Ekspres24.',
			defaultAdditionalServiceWaitingTime: 'Oczekiwanie kuriera na przesyłkę.',
			defaultAdditionalServicePocztaExpres24: 'Usługa "Ekspres24" gwarantuje, że przesyłki nadane w tej usłudze (adresowane do strefy A) zostaną doręczone już drugiego dnia po dniu nadania. Wyklucza się z usługami: Kurier48, Polecony, Przesyłka firmowa polecona, Polecony Zagraniczny, Global expres',
			defaultAdditionalPocztaServiceGuarantee0800: 'Doręczenie do godziny 8:00. Występuje tylko w połączeniu z usługą Ekspres24.',
			defaultAdditionalPocztaServiceDeliveryAfter1700: 'Doręczenie po godzinie 17:00. Występuje tylko w połączeniu z usługą Ekspres24.',
			defaultAdditionalPocztaServiceCheckContent: 'Usługa "Sprawdzenie zawartości". Występuje tylko w połączeniu z usługą Ekspres24.',
			defaultAdditionalPocztaServiceDeliveryOnTime: 'Doręczenie na wskazaną godzinę. Występuje tylko w połączeniu z usługą Ekspres24. Dostępny zakres: [13:00 - 20:00]',
			defaultCostCenter: 'Miejsce Powstania Kosztów',
			defaultCostCenterTooltip: 'wykorzystywane dla umów własnych DPD jako payerCostCenter. Maksymalna ilość znaków: 50',
		},
		headers: {
			settings: {
				general: 'Atrybuty ogólne',
				ups: 'Ustawienia dla UPS',
				inpost:'Ustawienia dla InPost',
				inpostkurier: 'Ustawienia dla InPost Kurier',
				poczta:'Ustawienia dla Poczta Polska',
				ruch:'Ustawienia dla Ruch',
				dpd:'Ustawienia dla DPD',
				dhl: 'Ustawienia dla DHL',
				fedex: 'Ustawienia dla FedEx'
			},
			urls: 'Lokalizacja API',
			ids: 'Dane dostępowe do API',
			senderAddress: 'Adres nadawcy',
			shipment: 'Domyślne ustawienia przesyłki',
			cod: 'Usługa pobraniowa',
			costCenter: 'Miejsce powstawania kosztów'
		}
    },
    facebook: {
        title: '[EN] Integracje > Facebook',
        label: '[EN] Kod do integracji'
    },
    freshmail: {
        title: '[EN] Integracje > Freshmail',
        labels: {
            enable: '[EN] Włącz integracje',
            apiKey: '[EN] Klucz do API',
            secretApiKey: '[EN] Sekretny klucz do API',
            listDropdown: '[EN] Wybierz listę mailingową',
            dropdownSelectLabel: '[EN] Wybierz'
        }
    },
    ceneo: {
        title: '[EN] Ceneo',
        tabs: {
            settings: '[EN] Ceneo > Ustawienia',
            categoryMapping: '[EN] Ceneo > Mapowanie kategorii'
        },
        inputs: {
            enable: '[EN] Włącz integracje z Ceneo',
            ceneoPath: '[EN] Ścieżka do wklejenia w Ceneo (dostępne tylko kopiowanie zawartości)',
            generateXLMAuto: '[EN] Generuj plik XML automatycznie',
            generateFileFrequency: '[EN] Co ile godzin generować plik (1 - 168h)',
            lastGeneratedFileDate: '[EN] Data ostatniego generowania pliku: ',
            useStockParam: '[EN] Używaj parametru STOCK - stan magazynowy',
            generateMappedProductsFile: '[EN] Generuj plik CENEO tylko z artykułami zmapowanymi'
        },
        pathCopiedAlert: '[EN] Ścieżka Ceneo skopiowana do schowka',
        productIndexDropdown: {
            label: '[EN] Indeks artykułu używany jako kod producenta Ceneo'
        },
        availableAvailParam: {
            label: '[EN] Parametr AVAIL w Ceneo dla artykułów dostępnych w sklepie'
        },
        unavailableAvailParam: {
            label: '[EN] Parametr AVAIL w Ceneo dla artykułów niedostępnych w sklepie'
        },
        defaultUnmappedCategory: {
            label: '[EN] Domyślna kategoria Ceneo dla artykułów z niezmapowanych kategorii'
        },
        buttons: {
            updateCeneoCategories: '[EN] Zaktualizuj kategorie Ceneo',
            preview: '[EN] Podgląd pliku XML',
            generateXML: '[EN] Generuj plik XML',
            save: '[EN] ZAPISZ ZMIANY',
            cleanMapping: '[EN] Wyczyść mapowanie',
            addMapping: '[EN] Dodaj mapowanie',
            assignCategory: '[EN] Przypisz',
            cancel: '[EN] Anuluj'
        },
        table: {
            headerLabels: {
                categoryShop: '[EN] Kategoria sklep',
                categoryCeneo: '[EN] Kategoria Ceneo',
                actions: "[EN] Akcje",
            },
            tooltips: {
                remove: '[EN] Usuń kategorię'
            },
            emptyTable: '[EN] Brak kateogrii do wyświetlenia',
            nameFiller: '[EN] [BRAK NAZWY]',
            deleteModal: {
                header: '[EN] Usuń mapowanie kategorii',
                body: '[EN] Czy napewno chcesz usunąć mapowanie kategorii?',
                confirm: '[EN] Usuń',
                cancel: '[EN] Wróć'
            }
        },
        modalHeader: '[EN] Przypisz kategorie',
        outsourceSystemCategories: '[EN] Kategorie Ceneo',
        shopCategories: '[EN] Kategorie sklepowe',
        availParamsLabels: {
            availableInOneDay: '[EN] Wysyłka w ciągu 24 godzin',
            availableInThreeDays: '[EN] Wysyłka w ciągu 3 dni',
            availableInWeek: '[EN] Wysyłka w ciągu tygodnia',
            availableInTwoWeeks: '[EN] Wysyłka w ciągu 14 dni',
            onRequest: '[EN] Towar na zamówienie',
            checkInStore: '[EN] Sprawdź status w sklepie',
            preSales: '[EN] Przedsprzedaż',
        },
        dropdownSelectLabel: '[EN] Wybierz',
        productIndexOptions: {
            catalogue: '[EN] Indeks katalogowy',
            trade: '[EN] Indeks handlowy',
            ean: '[EN] Kod kreskowy',
        }
    },
    google: {
        title: '[EN] Google',
        tabs: {
            googleAnalytics: '[EN] Google Analytics'
        },
        labels: {
            googleAnalyticsTag: '[EN] Identyfikator pomiaru Google Analytics',
			gtmContainerId: '[EN] Identyfikator kontenera GTM'
        }
    },
    chat: {
        title: '[EN] Chat',
        labels: {
            enabled: '[EN] Aktywny',
            script: '[EN] Skrypt'
        },
        scriptFormatAlert: '[EN] Skrypt musi znajdować się pomiędzy znakami <script></script>'
    },
    inspectlet: {
        title: 'Inspectlet',
        labels: {
            enabled: 'Aktywny',
            script: 'Skrypt'
        },
        scriptFormatAlert: 'Skrypt musi znajdować się pomiędzy znakami <script></script>'
    }
};

export default integrations;